import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"card text-center\"><div class=\"table table-danger\"><h5 class=\"category-social\"></h5><h4 class=\"card-caption\">&quot;Unauthorization&quot;</h4><p class=\"card-description\"> Silahkan refresh kembali untuk mengakses halaman ini </p></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.failed)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}